import React, {FC} from "react";
import {makeStyles} from "@mui/styles";
import {StyledButton, StyledDiv, StyledTypography} from "../../providers/layout/LayoutProvider";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {LocaleAtom, LocalizationsAtom} from "../../providers/localization/LocalizationProvider";
import clsx from "clsx";
import {Box} from "@mui/material";
import {usePublicPageConsumerCreateMutation} from "../../Queries";
import {CountryMapFactory} from "../../utility/CountryMapFactory";
import {ReturnsPagePath} from "../restricted/returns/ReturnsPage";
import {AccessContextData} from "../../providers/access/AppContextProvider";
import {LoginContext} from "../LoginContext";
import {useNavigate} from "react-router-dom";

export const KintobePage: FC<any> = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const [register] = usePublicPageConsumerCreateMutation()
   const appContext = useRecoilValue(AccessContextData);
   const locale = useRecoilValue(LocaleAtom);
   const setLoginContext = useSetRecoilState(LoginContext)
   const navigate = useNavigate();

   const classes = useStyles();

   async function registerNewUser() {
      const countries = CountryMapFactory.getCountriesFromDomain(window.location.hostname)
      const country = countries?.[0]?.alpha2 || 'DK'

      const consumer = await register({
         variables: {
            shopId: appContext.shopId,
            locale: locale,
            country: window.Shopify?.country || window.tradeInSession?.countryCode || country,
            currency: appContext.currency || window.Shopify?.currency?.active || window.tradeInSession?.currency
         }
      });
      if (consumer.data?.ConsumerCreate?.accessToken) {
         setLoginContext({
            accessToken: consumer.data.ConsumerCreate.accessToken
         })
         navigate(ReturnsPagePath());
      }
   }

   const onStart = async () => {
      await registerNewUser();
   }

   return <div className={"c2s-publicpage"}>
      <StyledDiv type={"front"} className={clsx(classes.container, "c2s-frontpage")}>
         <StyledDiv type={"front"} className={classes.leftSide}>
            <div className={classes.desktopPadding}>
               <StyledTypography variant={"h1"} className={classes.title}>
                  {localizations.publicPageTitle}
               </StyledTypography>
               <StyledTypography variant={"body1"}>
                  {localizations.publicPageDescription}
               </StyledTypography>
               <StyledTypography variant={"body1"}>
                  {localizations.publicPageDescription2}
               </StyledTypography>
               <div className={classes.tradeInBoxContainer}>
                  <StyledButton styletype={"front"} className={classes.button}
                                onClick={onStart}>
                     {localizations.publicPagePageStartButton}
                  </StyledButton>
               </div>
            </div>
         </StyledDiv>
         <StyledDiv type={"contrast"} className={classes.rightSide}>
            <div className={clsx(classes.desktopPadding, classes.rightPanel)}>
               <div className={"c2s-easybox-container"}>
                  <div className={"c2s-easybox-title"}>
                     <StyledTypography type={"contrast"} variant={"h1"} className={classes.centerText}>
                        {localizations.easyBoxTitle}
                     </StyledTypography>
                  </div>

                  <Box className={classes.list}>
                     <Box className={classes.listItem}>
                        <img style={{width: '100%'}} className={classes.listImage}
                             src={"https://cdn.shopify.com/s/files/1/0218/9194/0424/files/SELECTITEM.png?v=1718369514"}
                             alt={"Trade IT"}/>
                        <StyledTypography type={"contrast"} variant={"h2"} className={classes.text}>
                           {localizations.easyBoxSection1Title}
                        </StyledTypography>
                        <StyledTypography type={"contrast"} variant={"body1"}>
                           {localizations.easyBoxSection1Description}
                        </StyledTypography>
                     </Box>
                     <Box className={classes.listItem}>
                        <img style={{width: '100%'}} className={classes.listImage}
                             src={"https://cdn.shopify.com/s/files/1/0218/9194/0424/files/PACKIT.png?v=1718369515"}
                             alt={"Pack IT"}/>
                        <StyledTypography type={"contrast"} variant={"h2"} className={classes.text}>
                           {localizations.easyBoxSection2Title}
                        </StyledTypography>
                        <StyledTypography type={"contrast"} variant={"body1"}>
                           {localizations.easyBoxSection2Description}
                        </StyledTypography>
                     </Box>
                     <Box className={classes.listItem}>
                        <img style={{width: '100%'}} className={classes.listImage}
                             src={"https://cdn.shopify.com/s/files/1/0218/9194/0424/files/DROPITOFF.png?v=1718369514"}
                             alt={"Drop it off"}/>
                        <StyledTypography type={"contrast"} variant={"h2"} className={classes.text}>
                           {localizations.easyBoxSection3Title}
                        </StyledTypography>
                        <StyledTypography type={"contrast"} variant={"body1"}>
                           {localizations.easyBoxSection3Description}
                        </StyledTypography>
                     </Box>
                  </Box>
               </div>
            </div>
         </StyledDiv>
      </StyledDiv>
      <div className={clsx(classes.videoContainer, "video-container")}>
         {(localizations.publicPageFooter && localizations.publicPageFooter.length !== 0) &&
            <div dangerouslySetInnerHTML={{__html: localizations.publicPageFooter}}/>
         }
      </div>

   </div>
}
const useStyles = makeStyles({
   container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'top',
   },
   leftSide: {
      flexGrow: 1,
      width: '100%',
   },
   button: {
      marginTop: '25px',
      width: '250px',
      marginBottom: '40px'
   },
   rightSide: {
      flexGrow: 1,
      width: '100%',
   },
   desktopPadding: {
      padding: '20px 80px 20px 80px',
      alignItems: 'start',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '20px',
      marginBottom: '20px'
   },
   leftPanel: {
      textAlign: 'left',
      gap: '15px',
      display: 'flex',
      flexDirection: 'column'
   },
   rightPanel: {
      gap: '15px'
   },
   tradeInBoxContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      marginTop: '50px'
   },
   title: {
      marginBottom: '20px',
   },
   list: {
      alignItems: 'top',
      paddingTop: '0',
      display: 'flex',
      flexDirection: 'row',
      gap: '30px',
      marginTop: '30px'
   },
   listItem: {
      marginBottom: '30px'
   },
   listImage: {
      marginBottom: '20px'
   },
   '@media only screen and (max-width: 1000px)': {
      container: {
         flexDirection: 'column',
      } as any,
      desktopPadding: {
         padding: '20px'
      },
      listItem: {
         flexDirection: 'column',
         alignItems: 'center',
         textAlign: 'center',
         maxWidth: '600px',
         gap: '10px'
      },
      centerText: {
         textAlign: 'center'
      },
      list: {
         flexDirection: 'column',
         gap: '20px'
      }
   },
   videoContainer: {
      padding: '40px',
      marginTop: '40px'
   },
   backContainer: {
      marginTop: '20px'
   },
   centerText: {},
   text: {
      marginBottom: '10px'
   },
   signatureText: {},
   listAvatar: {},
   listText: {
      marginTop: '0'
   },
})
